<section class="lcl-search-ports-wrapper" [ngClass]="{ 'lcl-search-ports-wrapper-external': isExternal }">
  <div class="lcl-search-ports-from">
    <lcl-port-dropdown
      controlName="shippingFrom"
      [title]="'LCL_SHIPMENT.QUOTE.CREATE.WHERE_ARE_YOU_SHIPPING_FROM'"
      [fc]="departurePortFc"
      [isExternal]="isExternal"
      [isSubmitted]="isSubmitted"
      (selectPort)="onSelectFromPort.emit($event)"
      (onSearch)="onSearch.emit()"
      (onClear)="onClear.emit()"
    ></lcl-port-dropdown>
  </div>

  <div class="lcl-search-ports-delimiter">
    <img src="assets/icons/icon_from_to_white.svg" *ngIf="isExternal" />
    <img src="assets/icons/icon_from_to_blue.svg" *ngIf="!isExternal" />
  </div>

  <div class="lcl-search-ports-to">
    <lcl-port-dropdown
      controlName="shippingTo"
      [title]="'LCL_SHIPMENT.QUOTE.CREATE.WHERE_ARE_YOU_SHIPPING_TO'"
      [fc]="arrivalPortFc"
      [isExternal]="isExternal"
      [isSubmitted]="isSubmitted"
      (selectPort)="onSelectToPort.emit($event)"
      (onSearch)="onSearch.emit()"
      (onClear)="onClear.emit()"
    ></lcl-port-dropdown>
  </div>
</section>
